export type KsoStage = "hidden" | "creating" | "created" | "methods";

export const LOADER_SCREEN_WAVES = "waves";

export const DEFAULT_TRANSITION_DURATION = 700;

export const KSO_SHEET_EASE: [number, number, number, number] = [0.22, 1, 0.36, 1];

export const DEFAULT_LOADER_MIN_DURATION = 1400;
